import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinbanerpune() {



const cardData = {
  keyword: " Cab Service in Baner Pune   ",

"headingDescription": "SRS Cab Service offers easy and reliable Cab Booking in Pune, providing fast, safe, and comfortable rides for daily commutes, airport transfers, city tours, and outstation trips. Our well-maintained vehicles and professional drivers ensure a hassle-free travel experience. With flexible booking options, transparent pricing, and 24/7 customer support, SRS Cab Service makes booking your cab quick, convenient, and stress-free.",
"topPlaces": [
  {
    "title": "Pune Airport",
    "description": "Travelers using SRS Cab Service for Cab Booking often visit Pune Airport for seamless pick-ups and drop-offs with on-time service."
  },
  {
    "title": "Pune Railway Station",
    "description": "SRS Cab Service provides efficient cab transfers to Pune Railway Station, ensuring passengers reach their trains comfortably and on schedule."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Visitors booking cabs with SRS Cab Service often stop at Shaniwar Wada to explore the historic fort and enjoy Pune’s rich heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "SRS Cab Service users often visit Aga Khan Palace for a glimpse of Pune’s history and peaceful gardens during their city tours."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Adventure seekers use SRS Cab Service to reach Sinhagad Fort for trekking and scenic views outside the city."
  },
  {
    "title": "Baner Hills",
    "description": "Travelers booking cabs often head to Baner Hills for outdoor activities, hiking, and enjoying panoramic views of Pune."
  },
  {
    "title": "Balewadi High Street",
    "description": "Visitors using SRS Cab Service often explore Balewadi High Street for shopping, dining, and entertainment."
  },
  {
    "title": "PCMC Stadium",
    "description": "Sports enthusiasts use SRS Cab Service to reach PCMC Stadium for matches, events, and fitness activities."
  },
  {
    "title": "Durga Tekdi",
    "description": "Nature lovers booking cabs often visit Durga Tekdi for morning walks and a peaceful environment away from city traffic."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "Families and students using SRS Cab Service for Cab Booking often include Pimpri Chinchwad Science Park in their itinerary for educational and fun trips."
  }
],



services: [
{
name: "Cab Service in Baner",
description: "Cab service in Baner offers reliable transportation for local and outstation travel. Customers can book cabs for daily office and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Baner Cab Service",
description: "Baner cab service provides dependable travel for city and intercity routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Baner",
description: "Taxi service in Baner offers convenient transportation for daily and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Baner Taxi Service",
description: "Baner taxi service offers dependable transportation for local and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Baner",
description: "Cab booking Baner provides quick and easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Baner",
description: "Taxi booking Baner offers convenient booking services for local and airport travel. Customers can reserve taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Baner",
description: "Cab near Baner helps customers find nearby taxis instantly. Users can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Baner",
description: "Taxi near Baner offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Baner",
description: "Best cab service in Baner provides top-rated transportation for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Baner",
description: "Cheap cab service Baner offers affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Baner",
description: "Affordable cab service Baner provides cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Baner Cab Hire",
description: "Baner cab hire offers flexible rental options for local and outstation travel. Customers can book cabs for hourly and daily use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Baner Taxi Hire",
description: "Baner taxi hire provides convenient rental services for customers. Users can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Baner Cab for Airport",
description: "Baner cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Baner Airport Cab Service",
description: "Baner airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Baner Cab for Outstation",
description: "Baner cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Baner Pune",
description: "Cab service Baner Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Baner Pune",
description: "Taxi service Baner Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Baner Pune",
description: "Cab booking Baner Pune provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab Hire in Baner",
description: "Innova cab hire in Baner offers spacious SUV travel for families and corporate groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab on Rent in Baner",
description: "Innova Crysta cab on rent in Baner provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab on Rent in Baner",
description: "Ertiga cab on rent in Baner offers comfortable 7 seater travel for families and small groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab on Rent in Baner",
description: "Dzire cab on rent in Baner provides affordable sedan travel for daily and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab in Baner",
description: "Sedan cab in Baner offers budget-friendly travel for daily office and outstation journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "SUV Cab Hire in Baner",
description: "SUV cab hire in Baner offers spacious and comfortable travel for long-distance journeys. Customers can book vehicles for family and corporate trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with SUV cab services."
},
{
name: "Luxury Cab Hire Baner",
description: "Luxury cab hire Baner provides premium travel experience for corporate and VIP trips. Customers can enjoy high-end vehicles and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with luxury cab services."
},
{
name: "Tempo Traveller in Baner",
description: "Tempo traveller in Baner offers group travel solutions for corporate and family trips. Customers can book vehicles for outstation journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania on Rent Baner",
description: "Urbania on rent Baner provides luxury group travel for large families and corporate trips. Customers can book premium vehicles for long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania services."
}
],

tableData: [
["Cab Service in Baner","Taxi Service in Baner"],
["Baner Cab Service","Baner Taxi Service"],
["Cab Booking Baner","Taxi Booking Baner"],
["Cab Near Baner","Taxi Near Baner"],
["Best Cab Service in Baner","Cheap Cab Service Baner"],
["Affordable Cab Service Baner","Baner Cab Hire"],
["Baner Taxi Hire","Baner Cab for Airport"],
["Baner Airport Cab Service","Baner Cab for Outstation"],
["Cab Service Baner Pune","Taxi Service Baner Pune"],
["Cab Booking Baner Pune","Innova Cab Hire in Baner"],
["Innova Crysta Cab on Rent in Baner","Ertiga Cab on Rent in Baner"],
["Dzire Cab on Rent in Baner","Sedan Cab in Baner"],
["SUV Cab Hire in Baner","Luxury Cab Hire Baner"],
["Tempo Traveller in Baner","Urbania on Rent Baner"]
],



whychoose: [
  {
    WhyChooseheading: "Fast & Easy Cab Booking in Baner Pune",
    WhyChoosedescription: "SRS Cab Service offers quick and hassle-free cab booking in Baner Pune for daily travel, office commutes, airport transfers, and outstation trips with instant confirmation."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We provide affordable cab booking in Baner with clear and transparent pricing. You get complete fare details including tolls and driver charges without any hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Availability",
    WhyChoosedescription: "Our Baner cab booking service is available 24/7 for early morning airport drops, late-night pickups, emergency travel, and daily commuting needs."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars like Swift Dzire, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, Urbania vans, and luxury vehicles for all travel requirements."
  },
  {
    WhyChooseheading: "Professional Drivers & Safe Travel",
    WhyChoosedescription: "All our drivers are trained, experienced, and verified to ensure safe driving, polite behavior, and a smooth journey every time you book a cab."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Baner Area",
    WhyChoosedescription: "We provide quick doorstep pickup from homes, offices, hotels, and societies in Baner and nearby areas like Aundh, Balewadi, Wakad, and Pashan."
  },
  {
    WhyChooseheading: "Best for Airport & Outstation Trips",
    WhyChoosedescription: "Our cab booking service is ideal for Pune Airport transfers, Mumbai travel, corporate trips, family vacations, and long-distance journeys."
  },
  {
    WhyChooseheading: "Trusted Cab Booking Service in Baner",
    WhyChoosedescription: "SRS Cab Service is trusted by residents and professionals in Baner for reliable service, clean vehicles, affordable pricing, and on-time cab availability."
  }
]
}

const faqData = [
  { 
    question: "How can I book a cab in Baner Pune?", 
    answer: "You can easily book a cab in Baner Pune through our website or by calling us directly. The booking process is quick, simple, and provides instant confirmation for your ride." 
  },
  { 
    question: "Is cab booking available 24 hours in Baner?", 
    answer: "Yes, our cab booking service in Baner operates 24/7. You can book a cab anytime for airport drops, late-night travel, or emergency rides." 
  },
  { 
    question: "Do you provide airport cab service from Baner?", 
    answer: "Yes, we provide Pune Airport pickup and drop services from Baner with on-time pickup and professional drivers for a stress-free journey." 
  },
  { 
    question: "Which areas do you cover near Baner?", 
    answer: "We cover Aundh, Balewadi, Pashan, Wakad, and nearby areas. Our cab service is available across Pune and PCMC regions." 
  },
  { 
    question: "Which vehicles are available for cab booking?", 
    answer: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, Urbania vans, and luxury cars." 
  },
  { 
    question: "Do you provide outstation cab booking from Baner?", 
    answer: "Yes, we provide outstation cab booking from Baner to Mumbai, Nashik, Shirdi, Goa, Kolhapur, and many other destinations." 
  },
  { 
    question: "Is one-way cab booking available?", 
    answer: "Yes, one-way cab booking is available at affordable rates, especially for routes like Pune to Mumbai." 
  },
  { 
    question: "Are cab fares affordable in Baner?", 
    answer: "Yes, we offer affordable cab booking in Baner with transparent pricing and no hidden charges." 
  },
  { 
    question: "Are drivers professional and verified?", 
    answer: "Yes, all drivers are trained, experienced, and verified to ensure safe and comfortable travel." 
  },
  { 
    question: "Can I book cab for family trips?", 
    answer: "Yes, we provide spacious vehicles like Ertiga, Innova, and Tempo Travellers which are perfect for family and group travel." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback:
      "I booked a cab from Baner to Pune Airport and the experience was excellent. The driver arrived on time, the vehicle was clean and comfortable, and the journey was smooth without any delays.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab booking service in Baner Pune. I booked for Mumbai travel and everything was perfectly managed. The driver was professional, pricing was reasonable, and overall experience was great.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Baner Pune Cab Service",
  "description": "Reliable cab service in Baner, Pune with SRS Cab. Book taxis for local travel, airport transfers, and outstation trips. 24/7 service with Innova, Innova Crysta, Ertiga, Dzire, sedan, SUV, luxury, tempo traveller, and Urbania cab options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Baner",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411045",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5590",
    "longitude": "73.7800"
  },
  "url": "https://www.srscabservice.com/baner-pune-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Baner, Pune"
  }
};







  return (
    <div>
      <Helmet>
  <title>Cab Service in Baner Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Baner, Pune with SRS Cab. Local rides, airport transfers, and outstation trips available 24/7. Innova, Ertiga, sedan, SUV, luxury, tempo traveller, and Urbania cabs." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinbanerpune;